const OPEN_FREE_ACCOUNT_WALLET_NUDGE_KEY = "openFreeAccountWalletNudge";

export const markOpenFreeAccountFlow = () => {
  localStorage.setItem(OPEN_FREE_ACCOUNT_WALLET_NUDGE_KEY, "true");
};

export const consumeOpenFreeAccountFlow = () => {
  const shouldShow =
    localStorage.getItem(OPEN_FREE_ACCOUNT_WALLET_NUDGE_KEY) === "true";
  if (shouldShow) localStorage.removeItem(OPEN_FREE_ACCOUNT_WALLET_NUDGE_KEY);
  return shouldShow;
};
